// src/sections/Footer.js
import React from 'react';
import styled from 'styled-components';
import { colors, fonts, fontSizes, mq, space } from '../styles/tokens';
import { Icon } from '../components/Icon';

const Wrap = styled.footer`
  padding: ${space[4]} ${space[4]};
  border-top: 1px solid ${colors.border};
  font-family: ${fonts.mono};
  font-size: ${fontSizes.xs};
  color: ${colors.textMuted};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space[1]};
  text-align: center;

  ${mq.md} {
    flex-direction: row;
    justify-content: space-between;
    padding: ${space[4]} ${space[5]};
    text-align: left;
  }
`;

const Brand = styled.span`
  color: ${colors.textDim};
`;

const Center = styled.span`
  order: 3;
  ${mq.md} { order: 0; }
`;

const Right = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${space[2]};
`;

const TopButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${space[0.5]};
  color: ${colors.textDim};
  &:hover { color: ${colors.accent}; }
`;

const Footer = () => (
  <Wrap role="contentinfo">
    <Brand>fabio.dev</Brand>
    <Center>{'// built with React · Spline · soft animations'}</Center>
    <Right>
      <TopButton href="#home" aria-label="Back to top">
        <Icon name="arrowUp" size={12} /> top
      </TopButton>
      <span>© {new Date().getFullYear()}</span>
    </Right>
  </Wrap>
);

export default Footer;
